"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialAutocomplete = exports.MaterialAutocompleteUnstyled = void 0;
const chip_1 = require("client/components/material/chip");
const material_ui_1 = require("material-ui");
const Input_1 = require("material-ui/Input");
const Menu_1 = require("material-ui/Menu");
const react_1 = require("react");
const React = require("react");
const react_select_1 = require("react-select");
const ArrowDropDown_1 = require("material-ui-icons/ArrowDropDown");
const Clear_1 = require("material-ui-icons/Clear");
const Form_1 = require("material-ui/Form");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
require("react-select/dist/react-select.css");
const suggestions = [
    { label: "Afghanistan" },
    { label: "Aland Islands" },
    { label: "Albania" },
    { label: "Algeria" },
    { label: "American Samoa" },
    { label: "Andorra" },
    { label: "Angola" },
    { label: "Anguilla" },
    { label: "Antarctica" }
].map(suggestion => ({
    value: suggestion.label,
    label: suggestion.label
}));
const decorate = material_ui_1.withStyles(theme => ({
    "root": {},
    "formControl": {
        backgroundColor: "#fff",
        border: "solid 1px rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        height: 50,
        minWidth: "380px"
    },
    "inputLabel": {
        transform: "translate(0, 10px) scale(1)"
    },
    "inputLabelShrink": {
        transform: "translate(0, 1px) scale(0.8)"
    },
    "formControlDisabled": {
        color: "#aaa"
    },
    "helperText": {
        color: "#d81b60",
        position: "absolute",
        top: 50
    },
    // We had to use a lot of global selectors in order to style react-select.
    // We are waiting on https://github.com/JedWatson/react-select/issues/1679
    // to provide a better implementation.
    // Also, we had to reset the default style injected by the library.
    "@global": {
        ".Select-control": {
            "alignItems": "center",
            "background": "none",
            "border": "none",
            "display": "flex",
            "padding": "0 10px",
            "&:hover": {
                boxShadow: "none"
            }
        },
        ".Select-multi-value-wrapper": {
            display: "flex",
            flexGrow: 1,
            flexWrap: "wrap"
        },
        ".Select-multi-value-wrapper > div": {
            marginRight: "5px"
        },
        ".Select--multi .Select-input": {
            margin: 0
        },
        ".Select-noresults": {
            padding: theme.spacing.unit * 2
        },
        ".Select-placeholder, .Select--single .Select-value": {
            color: "rgba(0, 0, 0, 0.87) !important"
        },
        ".Select-placeholder": {
            opacity: 0.42
        },
        ".Select.is-focused:not(.is-open) > .Select-control": {
            border: "none",
            boxShadow: "none",
            outline: "none"
        },
        ".Select-menu": {},
        ".Select-menu div": {
            boxSizing: "content-box"
        },
        ".Select-arrow-zone, .Select-clear-zone": {
            cursor: "pointer",
            width: 24,
            zIndex: 1
        },
        // Only for screen readers. We can't use display none.
        ".Select-aria-only": {
            clip: "rect(0 0 0 0)",
            height: 1,
            margin: -1,
            overflow: "hidden",
            position: "absolute",
            width: 1
        }
    }
}));
class Option extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            this.props.onSelect(this.props.option, event);
        };
    }
    render() {
        const { children, isFocused, isSelected, onFocus } = this.props;
        return (React.createElement(Menu_1.MenuItem, { onFocus: onFocus, selected: isFocused, onClick: this.handleClick, component: "div", style: {
                fontWeight: isSelected ? 500 : 400
            } }, children));
    }
}
function SelectWrapped(props) {
    const { classes, searchable = true } = props, other = __rest(props, ["classes", "searchable"]);
    return (React.createElement(react_select_1.default, Object.assign({ optionComponent: Option, noResultsText: "No results found", arrowRenderer: () => React.createElement(ArrowDropDown_1.default, null), clearRenderer: () => React.createElement(Clear_1.default, null), valueComponent: (valueProps) => {
            const { value, children, onRemove } = valueProps;
            const onDelete = (event) => {
                event.preventDefault();
                event.stopPropagation();
                onRemove(value);
            };
            if (onRemove) {
                return (React.createElement(chip_1.MaterialChip, { classes: classes, label: children, onDelete: onDelete }));
            }
            return React.createElement("div", { className: "Select-value" }, children);
        } }, other)));
}
let MaterialAutocompleteUnstyled = class MaterialAutocompleteUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.value = "";
        this.state = {
            value: null
        };
        this.handleOnChange = (value) => {
            this.setState({
                value
            });
            // this.value = value;
            // this.props.onAction && this.props.onAction();
        };
    }
    render() {
        const { classes, disabled, error, helperText, pillbox = false, placeholder = "", required } = this.props;
        return (React.createElement(Form_1.FormControl, { classes: {
                root: classes.formControl
            }, error: error, disabled: disabled, required: required },
            React.createElement(Input_1.default, { fullWidth: true, inputComponent: SelectWrapped, disableUnderline: true, placeholder: placeholder, inputProps: {
                    value: this.value,
                    multi: pillbox,
                    onChange: this.handleOnChange,
                    simpleValue: true,
                    options: suggestions
                } }),
            React.createElement(Form_1.FormHelperText, { classes: {
                    root: classes.helperText
                } }, helperText)));
    }
};
__decorate([
    mobx_1.observable
], MaterialAutocompleteUnstyled.prototype, "value", void 0);
MaterialAutocompleteUnstyled = __decorate([
    mobx_react_1.observer
], MaterialAutocompleteUnstyled);
exports.MaterialAutocompleteUnstyled = MaterialAutocompleteUnstyled;
exports.MaterialAutocomplete = material_ui_1.withTheme()(decorate(MaterialAutocompleteUnstyled));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/autocomplete/autocomplete.tsx
// module id = 3661
// module chunks = 0